import { render, staticRenderFns } from "./PerfilEstatisticas.vue?vue&type=template&id=5a44ba8c&scoped=true"
import script from "./PerfilEstatisticas.vue?vue&type=script&lang=js"
export * from "./PerfilEstatisticas.vue?vue&type=script&lang=js"
import style0 from "./PerfilEstatisticas.vue?vue&type=style&index=0&id=5a44ba8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44ba8c",
  null
  
)

export default component.exports